<template>
    <span
        v-if="displaySelectedText && getStepHeaderSelectedText"
        class="title grey--text font-weight-regular first-letter-uppercase"
        :class="{ 'text-center': $vuetify.breakpoint.mdAndUp }"
        aria-hidden="true"
        v-text="getStepHeaderSelectedText"
    />
    <span
        v-else
        class="title text-center"
        v-text="$t(getStepHeaderTextKey)"
    />
</template>

<script>
import { mapGetters } from 'vuex';
import { stringDate } from '@/utils';

export const headerTextMap = {
    dynamicServiceFilters: 'appt.answerQuestions',
    service: 'appt.chooseService',
    serviceFilters: 'appt.answerServiceFilters',
    zipCodeFilter: 'appt.zipCodeFilter',
    place: 'appt.choosePlace',
    moment: 'appt.chooseMoment',
    data: 'appt.nominativeData',
    dataCollectionForm: 'appt.dataCollectionForm',
};

export default {
    name: 'stepper-header',
    props: {
        step: { type: Object, required: true },
        currentStep: { type: Number, required: true },
        selectedService: { type: Object, required: false, default: () => undefined },
        selectedPlace: { type: Object, required: false, default: () => undefined },
        selectedDate: { type: Object, required: false, default: () => undefined },
        selectedTime: { type: String, required: false },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
        }),

        getStepHeaderTextKey() {
            return headerTextMap[this.step.name] || '';
        },

        displaySelectedText() {
            return this.currentStep > this.step.num;
        },

        getStepHeaderSelectedText() {
            switch (this.step.name) {
                case 'dynamicServiceFilters':
                    return this.getDynamicServiceFiltersStepSelectedText;
                case 'service' :
                    return this.getServiceStepSelectedText;
                case 'serviceFilters' :
                    return this.getServiceFiltersStepSelectedText;
                case 'zipCodeFilter':
                    return this.getZipCodeFilterStepSelectedText;
                case 'place' :
                    return this.getPlaceStepSelectedText;
                case 'moment' :
                    return this.getMomentStepSelectedText;
                default:
                    return '';
            }
        },

        getDynamicServiceFiltersStepSelectedText() {
            return this.$i18n.messages[this.locale].appt.answeredQuestions;
        },

        getServiceStepSelectedText() {
            return this.selectedService
                ? this.selectedService['name' + this.upperLocale]
                : '';
        },

        getServiceFiltersStepSelectedText() {
            return this.$i18n.messages[this.locale].appt.answeredServiceFilters;
        },

        getZipCodeFilterStepSelectedText() {
            return this.$i18n.messages[this.locale].appt.answeredZipCodeFilter;
        },

        getPlaceStepSelectedText() {
            return this.selectedPlace
                ? this.selectedPlace['name' + this.upperLocale]
                : '';
        },

        getMomentStepSelectedText() {
            return this.selectedDate
                ? this.formatApptDateTime()
                : '';
        },
    },
    methods: {
        /**
         * Formats the appointment time
         * @returns {*|String|*}
         */
        formatApptDateTime() {
            let at = this.$i18n.messages[this.locale].appt.at;

            if (this.selectedTime) {
                return stringDate(this.selectedDate, this.locale) + at + this.selectedTime;
            }

            return stringDate(this.selectedDate, this.locale);
        },
    },
};
</script>
<style lang="scss">
    .first-letter-uppercase::first-letter {
        text-transform: capitalize;
    }
</style>
